// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

import { tns } from "tiny-slider/src/tiny-slider";

export default class TimelineByYearTinySlider extends WebComponent {
	didMount() {
		var slider = tns({
			container: '.timeline__list',
			// controlsContainer: '.timeline__controls',
			controls: false,
			loop: false,
			nav: false,
			fixedWidth: 190,
			slideBy: 'page',
			speed: 1000,
			autoplay: false,
			responsive: {
			   1024: {
				fixedWidth: 80,
			   }
			},
			mouseDrag: true
		});
	}
}



// WEBPACK FOOTER //
// ./fe/web-career/src/js/components/TinySliders/TimelineByYearTinySlider.js